import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';

import { NavbarService } from 'services/connectors/navbar.service';
import { Constants } from 'config/constants';

@Component({
    selector: 'tpc-calculator-methodology',
    templateUrl: './methodology.component.html',
    styleUrls: ['./methodology.component.css']
})
export class MethodologyComponent implements OnInit, OnDestroy {
    public calculatorName: string;
    public categoryName: string;
    private openSub: Subscription;
    public individualCalculator = Constants.calculators.individual;
    public businessCalculator = Constants.calculators.business;
    public eventsCalculator = Constants.calculators.events;
    public isOpened = false;
    private body: any;
    private modal: any;
    private timeout: any;

    constructor(private navbarService: NavbarService,
                @Inject(DOCUMENT) private document: any) {

        this.openSub = navbarService.openMethodology$.subscribe((data) => {
            this.categoryName = data.categoryName;
            this.calculatorName = data.calculatorName;
            this.open();
        });
        this.body = this.document.body;
    }

    ngOnInit() {
    }

    private scrollToCurrentCategory(): void {
        let name = this.calculatorName + '-' + this.categoryName,
            element = this.document.getElementsByName(name)[0],
            offsetTop: number;

        if (element) {
            offsetTop = element.getBoundingClientRect().top;
            this.animateScroll(this.modal, 800, offsetTop, true);
        }
    }

    private animateScroll(modal: any, scrollDuration: number, to: number, direction: boolean): void {
        let startTime = Date.now();
        let now, lengthDiff, frameCount,
            milliSecPerFrame = 16,
            stepLength,
            duration = 800,
            dTime,
            isAnimate = true;

        if (to === modal.scrollTop) {
            return;
        }

        let tick = () => {

            if (!this.isOpened) {
                return;
            }

            now = Date.now();

            dTime = now - startTime;

            lengthDiff = to - modal.scrollTop;

            frameCount = (scrollDuration - dTime + milliSecPerFrame) / milliSecPerFrame;

            stepLength = lengthDiff / frameCount;

            // to stop on exact pixel we need to use this condition, because sometimes step can be more than left pixel amount and scroll stops further than needed
            if (direction) {
                if (stepLength > lengthDiff) {
                    stepLength = lengthDiff;
                }
            } else {
                if (stepLength < lengthDiff) {
                    stepLength = lengthDiff;
                }
            }

            if (dTime > duration) {
                isAnimate = false;
            }
            modal.scrollTop += stepLength;
            if (isAnimate) {
                requestAnimationFrame(tick);
            }
        };

        tick();
    }

    public open(): void {
        this.body.style.overflow = 'hidden';

        if (this.isOpened) {
            return;
        }

        this.isOpened = true;

        if (!this.modal) {
            this.modal = this.document.getElementById('methodologyModal');
        }

        this.timeout = setTimeout(() => {
            this.scrollToCurrentCategory();
        }, 800);
    }

    public backToTop(e): void {
        e.preventDefault();
        this.animateScroll(this.modal, 800, 0, false);
    }

    private resetModalWindowHeight(): void {
        this.modal.scrollTop = 0;
    }

    public close(): void {
        this.isOpened = false;
        this.resetModalWindowHeight();
        this.body.style.overflow = 'initial';
        clearTimeout(this.timeout);
    }

    public closeOutside(e: any): void {
        let target = e.target.id,
            isMethodologyModalClicked = target === 'methodologyModal';

        if (isMethodologyModalClicked) {
            this.close();
        }
    }

    ngOnDestroy() {
        if (this.openSub) {
            this.openSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/methodology/methodology.component.ts